module.exports = __webpack_public_path__ + "img/1F63D.2c568724.svg";